export const projects = [
  {
    id: 'finflow',
    title: 'FinFlow Banking Platform',
    category: 'Fintech · Web App',
    summary:
      'A neobank dashboard handling 2M+ transactions/day with real-time fraud detection and multi-currency wallets.',
    metrics: [
      { value: '2M+', label: 'Daily txns' },
      { value: '99.98%', label: 'Uptime' },
      { value: '-43%', label: 'Fraud loss' },
    ],
    tags: ['React', 'Node.js', 'PostgreSQL', 'AWS'],
    accent: 'from-cyan/30 to-navy-500/40',
  },
  {
    id: 'medisphere',
    title: 'MediSphere EMR',
    category: 'Healthcare · SaaS',
    summary:
      'HIPAA-compliant electronic medical records platform serving 14 hospitals with offline-first sync.',
    metrics: [
      { value: '14', label: 'Hospitals' },
      { value: '320k', label: 'Records' },
      { value: '4.8★', label: 'User rating' },
    ],
    tags: ['React', 'GraphQL', 'Kubernetes', 'PostgreSQL'],
    accent: 'from-cyan-glow/30 to-navy-600/40',
  },
  {
    id: 'shopwave',
    title: 'ShopWave Commerce',
    category: 'Retail · Headless E-commerce',
    summary:
      'Headless storefront powering 800+ merchants with edge-rendered PDPs and a unified inventory graph.',
    metrics: [
      { value: '800+', label: 'Merchants' },
      { value: '0.4s', label: 'Avg load' },
      { value: '+62%', label: 'Conversion' },
    ],
    tags: ['Next.js', 'Node.js', 'Redis', 'Docker'],
    accent: 'from-silver/20 to-cyan-deep/30',
  },
  {
    id: 'fleetiq',
    title: 'FleetIQ Logistics',
    category: 'Logistics · IoT Platform',
    summary:
      'Real-time fleet tracking across 9,000 vehicles with predictive maintenance and route optimization.',
    metrics: [
      { value: '9k', label: 'Vehicles' },
      { value: '-18%', label: 'Fuel cost' },
      { value: '24/7', label: 'Monitoring' },
    ],
    tags: ['React', 'Go', 'Kafka', 'AWS'],
    accent: 'from-cyan/25 to-navy-700/40',
  },
  {
    id: 'learnlift',
    title: 'LearnLift LMS',
    category: 'EdTech · Mobile + Web',
    summary:
      'Adaptive learning platform with AI-driven curriculum paths for 1.2M students across SE Asia.',
    metrics: [
      { value: '1.2M', label: 'Students' },
      { value: '+37%', label: 'Completion' },
      { value: '6', label: 'Languages' },
    ],
    tags: ['React Native', 'Node.js', 'PostgreSQL', 'GCP'],
    accent: 'from-cyan-glow/25 to-navy-500/30',
  },
];
